























































































































































































import moment from 'moment-timezone'
import EventCardContainer from '@/components/layouts/EventCardContainer.vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import {
  ActionNames as PatientWithEventActionNames,
  GetterNames as PatientWithEventGetterNames,
} from '@/store/modules/patient-with-events/keys'
import {
  ActionNames as PatientNoteActionNames,
  GetterNames as PatientNotesGetterNames,
} from '@/store/modules/patient-note/keys'
import { toReadableTimeFromTimestamp } from '@/components/exercises/measure/filters'
import { getPatientName } from '@/utils/patients'
import { generatePdfFromHtml } from '@/utils/pdf-export'
import { getCsvDownloadFunction } from '@/http/utils'
import { createMixedEvents, MixedEvent } from '@/utils/mixed-events'
import { ExportDialogs } from '@/constants/exports'
import { Timeouts } from '@/constants/timeouts'

import StatusBadge from '@/components/sub-components/StatusBadge.vue'
import IsGeneratingExportDialog from '@/components/dialog/IsGeneratingExportDialog.vue'

export default {
  filters: { toReadableTimeFromTimestamp },
  components: {
    EventCardContainer,
    StatusBadge,
    IsGeneratingExportDialog,
  },
  inheritAttrs: false,
  props: {
    patientId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isInitialized: false,
      editingEventId: null,
      editingEventContent: '',
      apiRequestingEventId: null,
      legends: [
        {
          color: this.$vuetify.theme.themes.light.primary,
          label: 'Notes',
        },
        {
          color: this.$vuetify.theme.themes.light.red,
          label: 'Urgent Events',
        },
        {
          color: this.$vuetify.theme.themes.light.orange,
          label: 'Changes',
        },
      ],
      isGeneratingExport: false,
      isGeneratingExportDialogText: ExportDialogs.Pdf,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patientWithEvents, {
      patientWithEvents: PatientWithEventGetterNames.patientWithEvents,
    }),
    ...mapGetters(ModuleNames.patientNotes, {
      patientNotes: PatientNotesGetterNames.patientNotes,
    }),
    currentPatient() {
      return this.patientWithEvents.find(p => p.id === this.patientId)
    },
    currentPatientFullName() {
      return getPatientName(this.currentPatient)
    },
    currentPatientEvents() {
      return this.patientWithEvents.find(p => p.id === this.patientId)
    },
    currentPatientNotes() {
      return this.patientNotes.filter(p => p.id === this.patientId)
    },
    mixedEvents(): MixedEvent[] {
      return createMixedEvents({
        patientNotes: this.currentPatientNotes,
        patientWithEvents: this.currentPatientEvents,
        colors: this.$vuetify.theme.themes.light,
        userId: this.$store.state[ModuleNames.app].userId,
      })
    },
    mixedEventsForChosenDateRange() {
      return this.mixedEvents.filter(event => event.timestamp >= this.$attrs['start-timestamp'])
    },
    exportNotesForChosenPatientOptions() {
      return [
        {
          label: 'Export to PDF',
          icon: 'mdi-file-pdf-box',
          action: this.exportNotesForChosenPatientToPdf,
        },
        {
          label: 'Export to CSV',
          icon: 'mdi-google-spreadsheet',
          action: this.exportNotesForChosenPatientToCsv,
        },
      ]
    },
    pdfExportDateRange() {
      if (this.$attrs['display-weeks'] === Infinity) {
        return `All Notes`
      }
      return `${moment(this.$attrs['start-timestamp']).format('Do MMMM YYYY')} to ${moment(
        this.$attrs['end-timestamp']
      ).format('Do MMMM YYYY')}`
    },
    pdfExportTitle() {
      return `Agartee Dashboard - ${this.currentPatientFullName} Patient Notes - ${this.pdfExportDateRange}`
    },
  },
  async mounted() {
    await Promise.all([
      this[PatientWithEventActionNames.getPatientWithEvents](),
      this[PatientNoteActionNames.getPatientNotes](),
    ])
    this.isInitialized = true
  },
  methods: {
    ...mapActions(ModuleNames.patientWithEvents, [PatientWithEventActionNames.getPatientWithEvents]),
    ...mapActions(ModuleNames.patientNotes, [
      PatientNoteActionNames.getPatientNotes,
      PatientNoteActionNames.patchPatientNote,
      PatientNoteActionNames.deletePatientNote,
    ]),
    editEvent(event) {
      // only support note now
      this.editingEventId = event.id
      this.editingEventContent = event.content
      this.$nextTick(() => {
        const inputElement = this.$refs[event.id][0]
        if (inputElement) {
          inputElement.focus()
        }
      })
    },
    finishEditing() {
      // only support note now
      this.editingEventId = null
      this.editingEventContent = ''
    },
    async deleteEvent(event) {
      // only support note now
      this.apiRequestingEventId = event.id
      await this[PatientNoteActionNames.deletePatientNote]({ id: event.id })
      this.apiRequestingEventId = null
      this.finishEditing()
    },
    async updateEvent(event) {
      // only support note now
      if (this.editingEventContent !== event.content) {
        this.apiRequestingEventId = event.id
        await this[PatientNoteActionNames.patchPatientNote]({
          id: event.id,
          content: this.editingEventContent,
        })
        this.apiRequestingEventId = null
      }

      this.finishEditing()
    },
    async exportNotesForChosenPatientToPdf() {
      this.isGeneratingExportDialogText = ExportDialogs.Pdf
      this.isGeneratingExport = true
      await generatePdfFromHtml({
        filename: this.pdfExportTitle,
        source: this.$refs.pdfPatientNotes,
        orientation: 'portrait',
      })
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async exportNotesForChosenPatientToCsv() {
      this.isGeneratingExportDialogText = ExportDialogs.Csv
      this.isGeneratingExport = true
      const patientNotesCsv = getCsvDownloadFunction({
        path: `events-and-notes/patient/${this.patientId}`,
      })
      await patientNotesCsv()
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
  },
}
